import { PROCESSING_FEE_RATES } from './chunk-BFDKW44N.mjs';
import { toNumber } from './chunk-QFLAZK3L.mjs';
import { FeePayer } from '@equidefi/constants/payments';
export { FeePayer } from '@equidefi/constants/payments';

var roundCents = (value) => Math.round(value * 100) / 100;
var offeringToFeeRates = (offering) => ({
  investor_pays_fee: offering?.settings?.investor_pays_fee ?? false,
  credit_card_fee: toNumber(offering?.credit_card_fee),
  ach_fee: toNumber(offering?.ach_fee),
  crypto_fee: toNumber(offering?.crypto_fee),
  stripe_wire_fee: toNumber(offering?.stripe_wire_fee),
  manual_fee: toNumber(offering?.manual_fee)
});
var resolveFeePercent = (rates, paymentType) => {
  const map = {
    card: toNumber(rates.credit_card_fee),
    cashapp: toNumber(rates.credit_card_fee),
    link: toNumber(rates.credit_card_fee),
    apple_pay: toNumber(rates.credit_card_fee),
    google_pay: toNumber(rates.credit_card_fee),
    us_bank_account: toNumber(rates.ach_fee),
    crypto: toNumber(rates.crypto_fee),
    customer_balance: toNumber(rates.stripe_wire_fee),
    wire: toNumber(rates.manual_fee),
    check: toNumber(rates.manual_fee)
  };
  return map[paymentType] ?? 0;
};
var resolveTotalFeePercent = (rates, paymentType) => resolveFeePercent(rates, paymentType) + (PROCESSING_FEE_RATES[paymentType]?.percent ?? 0);
var computeFeeBreakdown = (rates, paymentType, _investmentAmount) => {
  const investmentAmount = toNumber(_investmentAmount);
  const investorPays = !!rates.investor_pays_fee;
  const effectiveRates = investorPays ? rates : { ...rates, manual_fee: 0 };
  const feePercent = resolveFeePercent(effectiveRates, paymentType);
  const applicationFeeAmount = roundCents(investmentAmount * feePercent);
  const payer = investorPays ? FeePayer.INVESTOR : FeePayer.ISSUER;
  if (payer === FeePayer.ISSUER) {
    return {
      payer,
      paymentType,
      feePercent,
      investmentAmount,
      applicationFeeAmount,
      processorFeeEstimate: 0,
      investorFeeTotal: 0,
      chargeAmount: investmentAmount
    };
  }
  const netTarget = investmentAmount + applicationFeeAmount;
  const processorRate = PROCESSING_FEE_RATES[paymentType];
  let chargeAmount;
  if (!processorRate) {
    chargeAmount = netTarget;
  } else {
    const { percent, fixed, cap } = processorRate;
    const uncappedCharge = (netTarget + fixed) / (1 - percent);
    const uncappedProcessorFee = percent * uncappedCharge + fixed;
    const processorFee = !cap ? uncappedProcessorFee : Math.min(uncappedProcessorFee, cap);
    chargeAmount = netTarget + processorFee;
  }
  chargeAmount = roundCents(chargeAmount);
  const investorFeeTotal = roundCents(chargeAmount - investmentAmount);
  const processorFeeEstimate = roundCents(investorFeeTotal - applicationFeeAmount);
  return {
    payer,
    paymentType,
    feePercent,
    investmentAmount,
    applicationFeeAmount,
    processorFeeEstimate,
    investorFeeTotal,
    chargeAmount
  };
};

export { computeFeeBreakdown, offeringToFeeRates, resolveFeePercent, resolveTotalFeePercent, roundCents };
